import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'

import { salaryFrequency } from 'modules/contracts/lib/frequencies'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const GrossSalary = ({ contractVersion, employee }: Props) => {
  const frequency = salaryFrequency(contractVersion.attributes.salary_frequency || '').toLowerCase()
  const currency = formatCurrency(
    contractVersion.attributes.salary_amount ?? 0,
    undefined,
    null,
    employeeLegalEntityId(employee)
  )

  const salary = currency && frequency ? `${currency} ${frequency}` : currency

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.compensation.gross_salary')}
      </Text>
      <Text size="400" weight="medium" color="grey1000">
        {salary}
      </Text>
    </Box>
  )
}

export default observer(GrossSalary)
